import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'button-cancel',
	templateUrl: './button-cancel.component.html',
	styleUrls: ['./button-cancel.component.scss'],
})
export class ButtonCancelComponent{
	@Output() eventClick = new EventEmitter<any>();

	cancel() {
		this.eventClick.emit();
	}
}
